import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('DisplayPin')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__display-pin" xmlns="http://www.w3.org/2000/svg" viewBox="11245 1605.894 32.222 46.418">
        <g id="group-376" transform="translate(11245 1605.894)">
          <path d="M33.377,56.738c-1.975,0-8.938-12.156-8.938-12.156-4.472-8.768-7.169-11.429-7.169-18.149a16.111,16.111,0,1,1,32.222,0c0,6.7-2.143,9.284-7.863,18.753C41.629,45.18,35.347,56.738,33.377,56.738Z" transform="translate(-17.27 -10.32)"/>
          <path style="fill: #fff" d="M46.293,40.1H39.62V35.224H37.861V40.1H31.187V31.944H28.34l10.4-10.6,2.945,3V23.228h3.5v4.642l3.971,4.049H46.293Z" transform="translate(-22.631 -15.656)"/>
        </g>
      </svg>
    ), el);
  });
};
